import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'HEALTH_PROFESSIONAL_LIST';

export default createListReducer(TEMPLATE_NAME);
